<template>
  <div class="myTable">
    <div class="searchNav" >
      <span><span class="searchNameStyle">短信 ：</span><el-input v-model="searchInfo.name" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <span><span class="searchNameStyle">客户类型：</span>
                <el-select v-model="searchInfo.type" clearable  @change="search" style="width: 150px;" placeholder="请选择">
                    <el-option
                            v-for="(item, i) in customersTypeList"
                            :key="i"
                            :label="item.value"
                            :value="item.value">
                    </el-option>
                </el-select>
            </span>
      <span><span class="searchNameStyle">手机号码 ：</span><el-input v-model="searchInfo.phone" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <span><span class="searchNameStyle">详细地址 ：</span><el-input v-model="searchInfo.address" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="name" label="客户名称" ></el-table-column>
        <el-table-column prop="contactName" label="联系人" ></el-table-column>
        <el-table-column prop="salesmanName" label="业务人" ></el-table-column>
        <el-table-column prop="type" label="客户类型" ></el-table-column>
        <el-table-column prop="employeeCount" label="用水人数" ></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="100" ></el-table-column>
        <el-table-column prop="devNum" label="绑定数量" ></el-table-column>
        <el-table-column prop="province" label="省" ></el-table-column>
        <el-table-column prop="city" label="城市" ></el-table-column>
        <el-table-column prop="district" label="区" ></el-table-column>
        <el-table-column prop="address" label="详细地址"  ></el-table-column>
        <el-table-column prop="remark" label="备注"  ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('customer-stat:view')"  @click="moreInfo(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:edit')" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:binding')" @click="deviceBinding(scope.row.id)">设备绑定</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form :model="addInfo" :rules="rules" ref="form" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户类型:" prop="type">
                      <el-select v-model="addInfo.type"  placeholder="请选择">
                        <el-option
                                v-for="item in customersTypeList"
                                :key="item.id"
                                :label="item.value"
                                :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名称:" prop="name">
                      <el-input v-model="addInfo.name" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="联系人:" prop="contactName">
                      <el-input v-model="addInfo.contactName" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="用水人数:" prop="employeeCount">
                      <el-input v-model="addInfo.employeeCount" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="手机号码:" prop="phone">
                      <el-input v-model="addInfo.phone" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="省:" prop="province">
                      <el-input v-model="addInfo.province" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="市：">
                      <el-input v-model="addInfo.city" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="区:" prop="district">
                      <el-input v-model="addInfo.district" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="详细地址:" prop="address">
                      <el-input v-model="addInfo.address" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="备注:" prop="remark">
                      <el-input v-model="addInfo.remark" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">所属业务</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form :model="addInfo" :rules="rules" ref="form" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="业务姓名:" prop="type">
                      <el-select v-model="addInfo.authUserId"  placeholder="请选择" clearable>
                        <el-option
                                v-for="item in salesmanAndPartnerList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="手机号码:">
                      {{currentPhoneNumber}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
              title="详情"
              :visible.sync="moreInfoDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户类型：">
                      {{addInfo.type}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名称：">
                      {{addInfo.name}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用水人数：">
                      {{addInfo.employeeCount}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电话：">
                      {{addInfo.phone}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="省：">
                      {{addInfo.province}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="市：">
                      {{addInfo.city}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="区：">
                      {{addInfo.district}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="详细地址：">
                      {{addInfo.address}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>

    <div>
      <el-dialog
              title="设备绑定"
              :visible.sync="deviceBindingDialogVisibleList"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">绑定设备信息</div>
            </div>
            <div style="margin-left: 15px;  padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
              <div style="text-align: right;margin-bottom: 10px; ">
                <el-button class="newAdd"  type="primary" @click="addForm" icon="el-icon-plus">绑定</el-button>
              </div>
              <div style="    min-height: 100px;" v-loading="tableLoading">
                <div style="padding: 10px; margin-bottom: 10px;" v-for="obj in deviceBindingList" :key="obj.id" >
                  <el-form label-width="100px">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="ICCID：">
                          {{obj.iccid}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="设备号：">
                          {{obj.imei}}
                        </el-form-item>
                      </el-col>
                    </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="绑定时间：">
                            {{obj.createTime}}
                          </el-form-item>
                        </el-col>
                      </el-row>
                    <el-row :gutter="20">
                      <el-col :span="24">
                        <el-form-item label="备注：">
                          {{obj.remark}}
                        </el-form-item>
                      </el-col>
                    </el-row>

                  </el-form>
                  <div style="text-align: right; margin-right: 20px;">
                    <button  style="background-color: rgb(133 134 136); color: white; border: none; padding: 6px 12px; cursor: pointer;" @click="removeDeviceBinding(obj)">解绑</button>
                  </div>
                </div>
              </div>
              <div v-if="deviceBindingList.length == 0" class="no-data"> 暂无绑定</div>
            </div>
          </div>
        </div>

      </el-dialog>

      <el-dialog
              title="设备绑定"
              :visible.sync="deviceBindingDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="设备号：">
                      <el-input v-model="bindingInfo.imei" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="备注：">
                      <el-input v-model="bindingInfo.remark" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deviceBindingDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveDeviceBinding">确 定</el-button>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  export default {
    name: "white-list",
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'新增客户',
        total:1,
        tableData: [],
        deviceBindingList: [],
        loading: false,
        dialogVisible: false,
        tableLoading: false,
        moreInfoDialogVisible: false,
        deviceBindingDialogVisibleList: false,
        deviceBindingDialogVisible: false,
        currentPage:1,
        customersTypeList:[], // 客户类型
        salesmanAndPartnerList:[], // 客户类型
        currentPhoneNumber:'',
        addInfo:{
          name:'',
          employeeCount:'',
          phone:'',
          province:'',
          city:'',
          district:'',
          address:'',
          address:'',
          taxRate:'',
          email:'',
          finalPayment:'',
          contactName:'',
          remark:'',
          authUserId:'',
        },
        bindingInfo:{
          customersId:'',
          imei:'',
          remark:'',
        },
        searchInfo:{
          name:'',
          type:'',
          employeeCount:'',
          phone:'',
          address:'',
          pageNumber:1,
          pageSize:50,
        },
        customerContactsList:[{"name":"","phone":"","post":""}],
        rules: {
          name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          phone: [
            { required: false, message: '请输入电话', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请输入电话'));
                } else if (!vm.validatePhoneNumber(value)) {
                  callback(new Error('输入的固定电话格式有误，请修改！'));
                } else {
                  callback();
                }
              }, trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
        },

      }
    },
    watch: {
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.type'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.phone'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.address'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'addInfo.authUserId'(newVal,oldVal){
        this.salesmanAndPartnerList.forEach(item=>{
          if (item.id == newVal){
            this.currentPhoneNumber = item.account;
          }
        })
      },
    },
    created: function () {
      this.pageInfo();
      // this.getPaymentTermList();
      this.getCustomersTypeList();
      this.getSalesmanAndPartnerList();
    },
    methods:{
      search(){
        this.pageInfo();
      },
      //改为全局方法
      addShow(){
        this.dialogVisible = true;
        this.customerContactsList = [{"name":"","phone":"","post":""}];
        this.currentPhoneNumber = "";
      },
      addRow(){
        this.customerContactsList.push({"name":"","phone":"","post":""});
      },
      removeRow(index){
        this.customerContactsList.splice(index, 1);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      validate(){

        let flag = true;
        let msg  = "";
        return {code:flag,msg:msg}
      },
      saveDeviceBinding(){
        axios.post('/devInfo/deviceBinding',this.bindingInfo).then(result => {
          if (result.code !== 200){
            console.log(result);
            this.msg("当前设备处于 "+result.message +" 状态，请更换其他的设备号。");
          }else {
            this.deviceBindingDialogVisible = false;
            this.getDeviceBindingList();
            this.pageInfo();
          }
        }).catch(err => {
          console.log(err);
        });
      },
      save(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            let validateObj = this.validate();
            if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
              this.addInfo.customerContactsStr = JSON.stringify(this.customerContactsList);
              if (validateObj.code){
                axios.post('/customers',this.addInfo).then(result => {
                  this.dialogVisible = false;
                  if (result.code !== 200){
                    console.log(result);
                  }
                  this.clearObj(this.addInfo); // 清空新增数据
                  this.pageInfo();
                }).catch(err => {
                  console.log(err);
                });
              }else{
                this.msg(validateObj.msg);
              }
            }else{  // 编辑
              if (validateObj.code){
                // 当前系列 是开启的
                this.addInfo.customerContactsStr = JSON.stringify(this.customerContactsList);
                axios.put('/customers',this.addInfo).then(result => {
                  this.dialogVisible = false;
                  if (result.code !== 200){
                    console.log(result);
                  }
                  this.pageInfo();
                  this.clearObj(this.addInfo); // 清空新增数据
                  this.addInfo.id = undefined;

                  this.dialogTitle="新增客户";
                }).catch(err => {
                  console.log(err);
                });
              }else{
                this.msg(validateObj.msg);
              }
            }
          } else {
            return false;
          }
        });
      },
      remove(id){
        axios.delete('/customers',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      unbinding(obj){
        console.info("obj:",obj);
        axios.delete('/devInfo/unbinding',{data: {id:obj.id,devId:obj.deviceStatusId}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.getDeviceBindingList();
          this.pageInfo();
        })
      },
      deviceBinding(id){
        // 查询绑定的设备 deviceBindingList
        //显示弹出
        this.deviceBindingDialogVisibleList = true;
        this.bindingInfo.customersId = id;
        this.getDeviceBindingList();
      },
      getDeviceBindingList(){
        // 查询绑定的设备 deviceBindingList
        axios.get('/devInfo/byCustomersId',{
          params: {customersId:this.bindingInfo.customersId}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.deviceBindingList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },

      addForm(){
        //显示弹出
        this.deviceBindingDialogVisible = true;
        this.bindingInfo.imei = "";
        this.bindingInfo.remark = "";
      },
      confirmRemove(id){
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      removeDeviceBinding(obj){
        this.$confirm('确定解绑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbinding(obj);
          this.$message({
            type: 'success',
            message: '解绑成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      edit(obj){
        this.dialogTitle = "客户编辑";
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.dialogVisible = true;
        this.salesmanAndPartnerList.forEach(item=>{
          if (item.id == obj.authUserId){
            this.currentPhoneNumber = item.account;
          }
        })
      },
      moreInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.moreInfoDialogVisible = true;
        //.getContactsLists(this.addInfo.id);
      },
      handleRowDblClick(row, column, event) {
        this.addInfo =JSON.parse(JSON.stringify(row));
        this.moreInfoDialogVisible = true;
        //this.getContactsLists(this.addInfo.id);
      },
      confirmChangeState(obj){
        let operation = obj.enabled?"禁用":"开启";
        this.$confirm('确定要'+operation+obj.account+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeState(obj.id);
          this.$message({
            type: 'success',
            message: operation+'成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+operation
          });
        });
      },
      changeState(id){
        axios.put("/user/disable",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      resetPassword(id){
        axios.put("/user/reset",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      pageInfo(){
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/customers',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;

          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },

      getCustomersTypeList(){
        axios.get('/dict/code',{
          params: {code:102}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.customersTypeList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
      getSalesmanAndPartnerList(){
        axios.get('/user/salesmanAndPartnerList',{
          params: {}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.salesmanAndPartnerList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
    },filters: {
      showState(val){
        if (val){
          return "可用";
        }
        return "不可用"
      },
      showVehicleType(val){
        if (val){
          return "车头";
        }
        return "挂车"
      },
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }
</style>
